export default __webpack_public_path__ + "static/media/icon-empty-assignedjobs.8a1cc146.svg";